import { CChart } from "@coreui/react-chartjs";
import { Chart, Colors } from "chart.js";

function PatientAgeChart() {
Chart.register(Colors);
  return (
    <div>
      <div class="row justify-content-center align-items-center ms-2 mt-2">
        <div class="col-12">
          <CChart
            type="pie"
            data={{
              labels: [
                "0-20",
                "21-35",
                "36-50",
                "51-60",
                "61-80",
                "80+",
              ],
              datasets: [
                {
                  backgroundColor: ['#38a2ebbf', '#f66384bf', '#4bc0c0bf', '#f89f40bf', '#9966ffbf', '#c9cbcfbf'],
                  borderColor: "rgba(220, 220, 220, 1)",
                  pointBackgroundColor: "rgba(220, 220, 220, 1)",
                  pointBorderColor: "#000",
                  data: [40, 20, 12, 39, 10, 40],
                },
              ],
            }}
            options={{
              plugins: {
                title: {
                  text: "Age Wise Distribution",
                  display: true,
                  align: "start"
                },
                legend: {
                    position: "bottom",
                    labels : {
                        boxWidth: 10
                    }
                }
              },
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default PatientAgeChart;